import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NewsletterForm = ({ testid = "newsletter" }) => {
  const [email, setEmail] = useState("");
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/newsletter`, { email });
      toast.success("Subscribed. Desk briefings will arrive as published.");
      setEmail("");
    } catch {
      toast.error("Subscription failed. Please try again.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form onSubmit={submit} data-testid={`${testid}-form`} className="card-line bg-[#121215] p-8">
      <span className="font-mono2 text-[10px] uppercase tracking-[0.3em] text-[#C9A227]">Desk Briefings</span>
      <h3 className="mt-3 font-display text-xl text-white tracking-wide">Market intelligence, on the record.</h3>
      <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
        Pricing context, corridor notes, and supply-demand dynamics — sent to verified
        counterparties and subscribers as briefings are published.
      </p>
      <div className="mt-6 flex flex-col sm:flex-row gap-3">
        <input
          type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
          placeholder="Institutional email"
          data-testid={`${testid}-input-email`}
          className="flex-1 bg-[#0A0A0B] card-line px-4 py-3.5 text-sm text-zinc-200 placeholder:text-zinc-600 focus:outline-none focus:border-[#C9A227]/60 transition-colors"
        />
        <button type="submit" disabled={sending} data-testid={`${testid}-submit`}
          className="px-7 py-3.5 text-[11px] uppercase tracking-[0.2em] font-medium text-[#0A0A0B] bg-gradient-to-r from-[#C9A227] to-[#D4AF37] hover:from-[#D4AF37] hover:to-[#E8C85A] transition-colors disabled:opacity-60">
          {sending ? "Subscribing…" : "Subscribe"}
        </button>
      </div>
    </form>
  );
};
